import { Model } from '@vuex-orm/core'
import { File } from 'src/store/models/channel/index.js'

export class Cloud extends Model {
  static entity = 'cloud'

  static fields () {
    return {
      id: this.uid(),
      uuid: this.string(null),
      size: this.attr(''),
      thumbnail: this.string(null),
      uploads: this.attr(''),
      downloads: this.attr(''),
      upstream: this.attr(''),
      downstream: this.attr(''),
      is_locked: this.boolean(null),
      user_id: this.attr(''),
      adapter_id: this.attr(''),
      channel_id: this.attr(''),
      activity_at: this.number(0),
      deleted_at: this.number(0),
      created_at: this.number(0),
      updated_at: this.number(0),
      files: this.hasMany(File, 'cloud_id'),
      can: this.attr({}),
      meta: this.attr({})
    }
  }
}

export default Cloud
